'use client';

import React, { useEffect } from 'react';
import styled from '@benzinga/themetron';
import { sanitizeHTML } from '@benzinga/frontend-utils';

export interface RadioGroupProps {
  className?: string;
  onChange: (value: RadioOption) => void;
  selected?: RadioOption;
  options: RadioOption[];
}

export interface RadioOption {
  id?: string | number;
  name?: string;
  value: string | number;
  label: string;
}

export const RadioGroup: React.FC<RadioGroupProps> = ({ className, onChange, options, selected }) => {
  const [selectedValue, setSelectedValue] = React.useState<string | undefined>(
    selected?.value ? String(selected?.value) : undefined,
  );

  useEffect(() => {
    selected?.value && setSelectedValue(String(selected?.value));
  }, [selected]);

  const handleChange = React.useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const value = event.target.value;
      setSelectedValue(value);
      const selectOption = options.find(option => option.value === 'value') as RadioOption;
      onChange && onChange(selectOption);
    },
    [onChange, options],
  );

  const handleClick = React.useCallback(
    (option: RadioOption) => {
      option.value && setSelectedValue(String(option.value));
      onChange && onChange(option);
    },
    [onChange],
  );

  return (
    <Container className={`radio-group-container${className ? `${className}` : ''}`}>
      {options &&
        options.map(option => (
          <fieldset className="flex items-center mb-0.5" key={option.value}>
            <input
              checked={selectedValue === String(option.value)}
              id={String(option.id)}
              name={option.label}
              onChange={handleChange}
              type="radio"
              value={option.value}
            />
            <label
              className="ml-2 text-sm font-medium"
              dangerouslySetInnerHTML={{ __html: sanitizeHTML(option.label) }}
              onClick={() => handleClick(option)}
            />
          </fieldset>
        ))}
    </Container>
  );
};

export default RadioGroup;

const Container = styled.div`
  &.radio-group-container {
    display: flex;
    flex-direction: column;

    label {
      margin-right: 0.5rem;
      font-size: ${({ theme }) => theme.fontSize.base};
    }
    input {
      /* background-color: ${({ theme }) => theme.colorPalette.white};
      border: 1px solid ${({ theme }) => theme.colors.border};
      border-radius: ${({ theme }) => theme.borderRadius.default};
      font-size: ${({ theme }) => theme.fontSize.base};
      line-height: 1.5rem;
      padding: 0.25rem 0.5rem; */
    }
  }
`;
